import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

const Editor = lazy(() => import('@/components/editor/editor').then((m) => ({ default: m.Editor })))

export const Route = createFileRoute('/d/$id')({
  component: EditorPage,
  head: () => ({
    meta: [
      { title: 'Editor — mkdn.app' },
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  }),
})

function EditorPage() {
  const { id } = Route.useParams()
  return (
    <main className="min-h-screen flex flex-col">
      <Suspense fallback={<div className="p-6 text-muted-foreground">Loading editor…</div>}>
        <Editor documentId={id} />
      </Suspense>
    </main>
  )
}
